import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
} from '@mui/material';

function Tooltip(props: MuiTooltipProps) {
  return <MuiTooltip arrow {...props} />;
}

export default Tooltip;
